import { VendorPerformance } from '../../../types';
import React, { useState } from 'react';
import { Spin } from 'antd';
import BaseTable from '../../../components/BaseTable';
import StatusTag from '../../../components/ui/StatusTag';

const VendorPerformanceTable = ({
  data,
  isLoading,
}: {
  data: VendorPerformance[] | undefined;
  isLoading: boolean;
}) => {
  const [spinning] = useState<boolean>(false);

  const columns = [
    {
      title: 'Code',
      dataIndex: 'vendorCode',
    },
    {
      title: 'Vendor',
      dataIndex: 'venderDescription',
    },
    {
      title: 'P.O. Number',
      dataIndex: 'pono',
    },
    {
      title: 'Order Date',
      dataIndex: 'orderDate',
    },
    {
      title: 'Required Date',
      dataIndex: 'requiredDate',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      render: (_text: any, record: VendorPerformance) => (
        <StatusTag status={record.status} />
      ),
    },
  ];

  return (
    <>
      <Spin spinning={spinning} fullscreen />
      <BaseTable
        dataSource={data || []}
        isLoading={isLoading}
        columns={columns}
        module={'Vendor Performance'}
      />
    </>
  );
};

export default VendorPerformanceTable;
